export enum ALM_MODES  {
    SAVED = 'SAVED',
    DRAFT = 'DRAFT'
}